import api from '../utils/api';

export const getFinancialScoreboard = (config = {}) => {
    const { options } = config;
    return api({
        url: 'api/financials',
        method: 'GET',
        ...options,
    });
};